<template>
    <svg width="13px" height="8px" viewBox="0 0 13 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Down Arrow</title>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="04--Kitchen-View-Appliances-Expanded" transform="translate(-326.000000, -1333.000000)" fill="#3D3D3D">
              <g id="Group-7" transform="translate(0.000000, 105.000000)">
                  <g id="Kitchen" transform="translate(0.000000, 1172.000000)">
                      <g id="Group-4" transform="translate(0.000000, 37.000000)">
                          <polygon id="ic_expand_collapse" points="327.930286 19.424 332.514286 24.032 337.098286 19.424 338.514286 20.84 332.514286 26.84 326.514286 20.84"></polygon>
                      </g>
                  </g>
              </g>
          </g>
      </g>
    </svg>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
